"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var core_1 = require("@blueprintjs/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var Overlay_1 = __importDefault(require("../Overlay"));
var style_scss_1 = __importDefault(require("./style.scss"));
var MoreOptions = function (props) {
    var _a;
    var show = props.show, onToggle = props.onToggle, className = props.className, items = props.items, element = props.element;
    var handleToggle = function (e) {
        e.stopPropagation();
        onToggle(!show);
    };
    var onAction = function (e, action) {
        e.stopPropagation();
        onToggle(false);
        action();
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        !element && (react_1.default.createElement("button", { onClick: handleToggle, type: "button", className: (0, classnames_1.default)(style_scss_1.default.moreBtn, 'more-options-btn', (_a = {}, _a[style_scss_1.default.active] = show, _a)) },
            react_1.default.createElement("span", { className: style_scss_1.default.moreBtnDots }))),
        element,
        show && (react_1.default.createElement("ul", { className: (0, classnames_1.default)(style_scss_1.default.moreMenu, 'more-options-more-menu', className) }, items.map(function (item, index) {
            var _a, _b;
            var action = item.action, className = item.className, content = item.content, icon = item.icon, label = item.label, type = item.type, selected = item.selected;
            return (react_1.default.createElement("li", { key: index, className: className }, content ? (content) : (react_1.default.createElement(react_1.Fragment, null,
                action && (react_1.default.createElement(core_1.Button, { icon: icon, minimal: true, className: (0, classnames_1.default)(style_scss_1.default.moreMenuItem, (_a = {},
                        _a[style_scss_1.default.delete] = type === 'delete',
                        _a['more-options-selected-option'] = selected,
                        _a)), onClick: function (e) { return onAction(e, action); } },
                    label,
                    selected && react_1.default.createElement(core_1.Icon, { icon: "tick", iconSize: 12 }))),
                !action && (react_1.default.createElement("span", { className: (0, classnames_1.default)(style_scss_1.default.moreMenuItem, style_scss_1.default.noHover, (_b = {}, _b[style_scss_1.default.delete] = type === 'delete', _b)) },
                    react_1.default.createElement(core_1.Icon, { icon: icon, iconSize: 16 }),
                    label))))));
        }))),
        show && react_1.default.createElement(Overlay_1.default, { onClick: handleToggle })));
};
exports.default = MoreOptions;
